import { useLocation, Link } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const ServiceLink = ({ href, route, children }) => (
    isHome ? (
      <a href={href} className="footer-link">{children}</a>
    ) : (
      <Link to={route} className="footer-link">{children}</Link>
    )
  );

  return (
    <footer className="footer" data-testid="footer">
      <div className="container-flow relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
              <span className="text-[#00AFFF]">FLOW</span>
            </h3>
            <p className="text-[#94A3B8] max-w-sm mb-4 leading-relaxed text-sm">Spécialiste en installation de climatisation et ventilation haut de gamme. Solutions sur mesure pour studios, hôtels, cinémas privés, bureaux et résidences premium.</p>
            <div className="text-[#94A3B8] text-sm mb-4">
              <p>9 rue Quentin</p>
              <p>93300 Aubervilliers, France</p>
              <p className="mt-2"><a href="tel:+33650448840" className="hover:text-[#00AFFF] transition-colors">06 50 44 88 40</a></p>
            </div>
            <a href="mailto:contact@flow-air.com" className="text-[#00AFFF] hover:underline text-sm">contact@flow-air.com</a>
          </div>
          <div className="text-center md:text-left">
            <h4 className="font-semibold mb-4 text-white text-sm">Services</h4>
            <ul className="space-y-2">
              <li><ServiceLink href="#installation" route="/installation">Installation HVAC</ServiceLink></li>
              <li><ServiceLink href="#services" route="/maintenance">Maintenance</ServiceLink></li>
              <li><ServiceLink href="#services" route="/maintenance">Dépannage</ServiceLink></li>
            </ul>
          </div>
          <div className="text-center md:text-left">
            <h4 className="font-semibold mb-4 text-white text-sm">Secteurs</h4>
            <ul className="space-y-2">
              <li><ServiceLink href="#secteurs" route="/secteurs/studios">Studios musique</ServiceLink></li>
              <li><ServiceLink href="#secteurs" route="/secteurs/hotellerie">Hôtels</ServiceLink></li>
              <li><ServiceLink href="#secteurs" route="/contact">Cinémas privés</ServiceLink></li>
              <li><ServiceLink href="#secteurs" route="/secteurs/tertiaire">Bureaux</ServiceLink></li>
              <li><ServiceLink href="#secteurs" route="/secteurs/residentiel">Résidentiel</ServiceLink></li>
            </ul>
          </div>
        </div>
        <div className="footer-divider mb-6" />
        <div itemScope itemType="https://schema.org/LocalBusiness">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <div className="text-[#64748B] text-xs">
              <span itemProp="name">FLOW</span> • 
              <span itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                <span itemProp="streetAddress"> 9 rue Quentin</span>, 
                <span itemProp="postalCode"> 93300</span>
                <span itemProp="addressLocality"> Aubervilliers</span>, 
                <span itemProp="addressCountry"> France</span>
              </span>
            </div>
            <div className="text-[#475569] text-xs flex flex-wrap items-center justify-center md:justify-start gap-x-3 gap-y-1">
              <span>© {new Date().getFullYear()} FLOW. Tous droits réservés.</span>
              <span className="text-[#334155] hidden md:inline">•</span>
              <Link to="/mentions-legales" className="hover:text-[#00AFFF] transition-colors" data-testid="footer-mentions-legales">Mentions légales</Link>
              <span className="text-[#334155] hidden md:inline">•</span>
              <Link to="/politique-de-confidentialite" className="hover:text-[#00AFFF] transition-colors" data-testid="footer-politique-confidentialite">Politique de confidentialité</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
